import React from 'react'
import { HeroSection } from './Components/HeroSection';
import { StatsSection } from './Components/StatsSection';
import { AboutSection } from './Components/AboutSection';
import { ValueSection } from './Components/ValueSection';
import { TestimonialsSection } from './Components/TestimonialsSection';

export const Home = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <ValueSection />
      {/* <TestimonialsSection /> */}
    </div>
  )
}
